<i18n src="@/i18n/components/help.json"></i18n>

<template>
  <div>
    <section class="hero c-background--image">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-2 has-text-centered c-heading__title">
            {{ $t('helpTitle')}}
          </h1>

          <div class="columns is-mobile">
            <div class="column is-8-desktop is-offset-2-desktop">
              <div class="box">
                <div class="content">
                  <video controls loop class="c-video c-video--is-responsive">
                    <source src="/static/help-event-creation.mp4" type="video/mp4">
                  </video>

                  <p class="help has-text-grey has-text-centered">{{ $t('videoLegend')}}</p>
                </div>

                <div class="content">
                  <p>{{ $t('helpText')}}</p>
                </div>

                <form action="https://formspree.io/pulsar.dev.team@gmail.com" method="POST" novalidate>
                  <div class="field">
                    <label class="label">{{ $t('name')}}</label>
                    <div class="control">
                      <input class="input" type="text" :placeholder="$t('enterName')" v-model="name" name="name" required>
                    </div>
                  </div>

                  <div class="field">
                    <label class="label">{{ $t('email')}}</label>
                    <div class="control has-icons-left has-icons-right">
                      <input class="input" :class="{'is-danger': this.email && !isValidEmail}" type="text" :placeholder="$t('enterEmail')" v-model="email" name="email" required>
                      <span class="icon is-small is-left"><i class="fa fa-envelope"></i></span>
                      <span v-if="this.email && !isValidEmail" class="icon is-small is-right"><i class="fa fa-warning"></i></span>
                    </div>
                    <p v-if="this.email && !isValidEmail" class="help is-danger">{{ $t('emailError') }}</p>
                  </div>

                  <div class="field">
                    <label class="label">{{ $t('message')}}</label>
                    <div class="control">
                      <textarea class="textarea" :placeholder="$t('enterMessage')" v-model="message" name="message" required></textarea>
                    </div>
                  </div>

                  <div class="control">
                    <button class="button is-primary" :disabled="!canSubmit()">{{ $t('submit')}}</button>
                  </div>
                </form>

              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'help',
    data () {
      return {
        name: '',
        email: '',
        message: ''
      }
    },
    computed: {
      isValidEmail: function () {
        let regex = new RegExp('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}')
        return regex.test(this.email)
      }
    },
    methods: {
      canSubmit () {
        return this.name && this.isValidEmail && this.message
      }
    }
  }
</script>

<style lang="scss" scoped>
  .c-video--is-responsive {
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Help.vue